"use strict";
var FlightValidationStatus;
(function (FlightValidationStatus) {
    FlightValidationStatus[FlightValidationStatus["notSet"] = 0] = "notSet";
    FlightValidationStatus[FlightValidationStatus["None"] = 1] = "None";
    FlightValidationStatus[FlightValidationStatus["Valid_SkipTripEligibility"] = 2] = "Valid_SkipTripEligibility";
    FlightValidationStatus[FlightValidationStatus["Invalid"] = 3] = "Invalid";
    FlightValidationStatus[FlightValidationStatus["Valid_VerifyTripEligibility"] = 4] = "Valid_VerifyTripEligibility";
})(FlightValidationStatus = exports.FlightValidationStatus || (exports.FlightValidationStatus = {}));



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/flight-validation-status.enum.js